import {createReducer} from '@reduxjs/toolkit';
import {load} from '../actions/items.js';

const initialState = {
  loading: false,
  error: null,
  items: [],
};

export default createReducer(initialState, builder => {
  builder.addCase(load.pending, state => ({
    ...state,
    loading: true,
    items: [],
  }));

  builder.addCase(load.fulfilled, (state, {payload}) => {
    return {
      ...state,
      loading: false,
      error: null,
      items: payload,
    };
  });

  builder.addCase(load.rejected, (state, {payload}) => ({
    ...state,
    loading: false,
    error: payload,
  }));
});
